import React from "react";
import "./Card.scss";

const Card = ({ children, className, title, icon, img, style }) => {
    return (
        <div className={`Card${className ? ` ${className}` : ''} animate__animated animate__fadeIn`} style={style}>
            {(title || icon || img) && (
                <div className="title-container">
                    {title && <div className="card-title">{title}</div>}
                    {icon  && <label data-icon={icon} className="icon card-icon" />}
                    {img   && <img src={img} alt="Card Icon" className="card-img" />}
                </div>
            )}
            {children}
        </div>
    );
}
export default Card;